import { Button } from "antd";
import styled from "styled-components";

export const DrawerWrapper = styled.div`
 .ant-drawer {
    border-radius: 12px;    /* Adds border radius to the Drawer */
    top: 50px;              /* Adds space from the top */
    right: 20px;            /* Adds space from the right */
    left:20px;
  }

    /* Target the custom class added to the Ant Design Drawer component */
  .custom-drawer {
    /* Adding border-radius to the entire drawer */
    .ant-drawer-content {
      border-radius: 12px;  /* Border radius to the content area */
      top: 50px;            /* Top margin */
      right: 20px;          /* Right margin */
    }
    
    /* Optional: Change the drawer overlay background */
    .ant-drawer-mask {
      opacity: 0.5;         /* Example of changing opacity of the overlay */
    }
  }
    .ant-drawer-left>.ant-drawer-content-wrapper {
    background:#000 !important;
     left:20px  !important; 
    }
 
`;
export const DrawerContent = styled.div`
display : flex;
flex-direction: column;
`;
export const DrawerlabelContainer = styled.div`
display : flex;
justify-content : space-between;
align-items:center;
`;
export const DrawerHeaderLabel = styled.div`
font-family: 'Manrope', sans-serif;
font-weight: 600;
font-size: 16px;
leading-trim: Cap height;
line-height: 30px;
letter-spacing: 0%;
vertical-align: middle;
color: #1B2028;
`;
export const HorizondalLine = styled.hr`
  border: 1px solid #f3f4f7;
  width: 100%;
  margin-bottom: 28px;
  margin-top: 12px;
`;
export const DrawerFormLabel = styled.div`
font-family: 'Manrope', sans-serif;
font-weight: 500;
font-size: 14px;
leading-trim: Cap height;
line-height: 20px;
letter-spacing: 0%;
vertical-align: middle;
color: #1B2028;
`;
export const DrawerFormValue = styled.div`
font-family: 'Manrope', sans-serif;
font-weight: 500;
font-size: 13px;
leading-trim: Cap height;
line-height: 100%;
letter-spacing: 0px;
vertical-align: middle;
color: #48566B;
`;
export const DrawerFormBody = styled.div`
display:flex;
flex-direction :column;
gap:12px;
`
export const CancelButton = styled(Button)`
background-color: ${(props) => props.bg || "#0C53BB"};
  color: ${(props) => props.color || "#fff"};
  padding: 12px 20px;
  border-radius: ${(props) => props.borderradius || "6px"};
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 3.84px;
  
  height: 32px;
  text-align: center;
  opacity: ${(props) => (props.disabled ? "0.4" : "1")};
  font-family: 'Manrope', sans-serif;
  leading-trim: Cap height;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;

  &:hover {
    background-color:${(props) => `${props.hoverbg} !important` || "#0a4296 !important"}; 
    color: ${(props) => `${props.hovercolor} !important` || "#ffff !important"};
    border: 1px solid #DDE2E9!important;
  }

  &:focus {
    outline: none;
    border: none;
  }
`
export const NotificationWrapper = styled.div`
display:flex;
flex-direction:column;
width:100%;
gap:8px;
padding-bottom:15px;
`
export const NotificationWrapperContent = styled.div`
display:flex;
justify-content: space-between;
padding-top:20px
`
export const NotificationHeaderWrapper = styled.div`
display:flex;
align-items: center;
gap: 5px;
opacity:${(props) => props.opacity==="true"?0.5:1};

`
export const NotificationHeader = styled.div`
font-family: 'Manrope', sans-serif;
font-weight: 600;
font-size: 12px;
leading-trim: Cap height;
line-height: 100%;
letter-spacing: 0%;
text-transform: capitalize;
color:;
color:${(props) => props.color?props.color:"#9B40C2"};
`
export const NotificationBadge = styled.div`
width:5px;
height:5px;
background:#3A74C8;
border-radius: 4px;
`
export const NotificationMesaageWrapper = styled.div`
display :flex;
justify-content:space-between;
gap:10px;
opacity:${(props) => props.opacity==="true"?0.5:1};
`
export const NotificationTime = styled.div`
color:#1B2028;
white-space:nowrap;
font-family: 'Manrope', sans-serif;
font-weight: 600;
font-size: 12px;
leading-trim: Cap height;
line-height: 20px;
letter-spacing: 0px;
vertical-align: middle;
`
export const NotificationItem = styled.div`
cursor:pointer;
` 
export const LoadMoreButton = styled(Button)`
color:#0C53BB !important;
font-family: 'Manrope', sans-serif;
font-weight: 600;
font-size: 13px;
leading-trim: Cap height;
line-height: 100%;
letter-spacing: 0px;
vertical-align: middle;

`
export const NotificationMessage = styled.div`
  color: #1b2028;
  font-family: 'Manrope', sans-serif;
  font-weight: 600;
  font-size: 13px;
  leading-trim: Cap height;
  line-height: 20px;
  letter-spacing: 0px;
  vertical-align: middle;
  word-break: break-word;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
`
export const RemindSpan = styled.span`
color:#5A6C87;
font-family: 'Manrope', sans-serif;
font-weight: 600;
font-size: 12px;
leading-trim: Cap height;
line-height: 100%;
letter-spacing: 0%;
text-transform: capitalize;
`